export default __webpack_public_path__ + "static/media/photo-icon.db99ba2b.svg";